import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import { IGlobalState } from '../../../model/IGlobalState';
import AllHolders from './AllHolders';

// url segment → tab; no segment = All holders. Top holders / Holdings movement / Reports land here as they are built.
const tabs = [
    { path: '', label: 'All holders', icon: <FiUsers />, component: AllHolders },
];

const ShareRegistry: React.FC = () => {
    const stock = useSelector((state: IGlobalState) => state.currentStock);
    const history = useHistory();
    const { tab = '' } = useParams<{ tab?: string }>();
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    return <div className="v2-page share-registry-v2">
        <div className="sub-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/share-registry${x.path && `/${x.path}`}`)}>{x.icon} {x.label}</button>)}
        </div>

        <div className="page-header">
            <h1>Share Registry</h1>
            <p>{stock && `${stock.companyName} (${stock.ticker}:${stock.exchange})`}</p>
        </div>

        <current.component />
    </div>;
};

export default ShareRegistry;
